/* Native Shopify signup. Demo mode has no form and never submits. */
(() => {
  const instances = window.WscDiamondPopups || (window.WscDiamondPopups = new Map());
  function init(root) {
    if (instances.has(root.id)) return;
    const demo = root.dataset.mode === 'demo';
    const editor = root.dataset.editor === 'true';
    const query = new URLSearchParams(location.search).get('wsc_diamond_demo');
    const requested = demo && /^[123]$/.test(query || '') ? Number(query) : 0;
    const modal = root.querySelector('[role="dialog"]');
    const slides = [...root.querySelectorAll('.wsc-pop__slide')];
    const segs = [...root.querySelectorAll('.wsc-pop__seg')];
    const steps = [...root.querySelectorAll('[data-step]')];
    const input = root.querySelector('input[type="email"]');
    const form = demo ? null : root.querySelector('form');
    const error = root.querySelector('[role="alert"]');
    const submit = root.querySelector('[data-claim]');
    const submitLabel = submit.textContent;
    const video = root.querySelector('video');
    const poster = root.querySelector('[data-poster]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const on = (target, name, callback) => target.addEventListener(name, callback, {signal: controller.signal});
    const keys = {pending:'wsc_diamond_pending_v1', dismissed:'wsc_diamond_dismissed_v1', submitted:'wsc_diamond_submitted_v1'};
    let timer, copyTimer, submitTimer, index = 0, step = 1, previousFocus, previousOverflow, pending = 0;
    let gate, destroyed = false, storageAvailable = true, ownResult = '', submitting = false;
    let navigating = false, submissionDismissed = false, challengeActive = false, retryDue = false, challengeFrame;
    let challengeObserver, challengePoll;
    let inertNodes = [];
    // Corner badge: sits beside the hidden popup root and reopens it.
    const badge = demo ? null : document.querySelector('[data-wsc-voucher-badge][aria-controls="' + root.id + '"]');
    const viewport = window.visualViewport;
    const viewportProperties = ['--wsc-vv-height','--wsc-vv-top','--wsc-vv-width','--wsc-vv-center-x'];
    let viewportFrame = 0, revealInput = false;
    function clearViewport() {
      cancelAnimationFrame(viewportFrame); viewportFrame = 0; revealInput = false;
      viewportProperties.forEach(name => root.style.removeProperty(name));
      root.classList.remove('is-email');
    }
    function syncViewport(ensureInput = false) {
      if (root.hidden || destroyed) return;
      const positive = (value, fallback) => Number.isFinite(value) && value > 0 ? value : fallback;
      const height = positive(viewport?.height, positive(window.innerHeight, 600));
      const width = positive(viewport?.width, positive(window.innerWidth, 320));
      const top = Number.isFinite(viewport?.offsetTop) ? Math.max(0, viewport.offsetTop) : 0;
      const left = Number.isFinite(viewport?.offsetLeft) ? Math.max(0, viewport.offsetLeft) : 0;
      const center = Number.isFinite(left + width / 2) ? left + width / 2 : width / 2;
      [height, top, width, center].forEach((value, i) => root.style.setProperty(viewportProperties[i], value + 'px'));
      if (!ensureInput || step !== 2 || document.activeElement !== input) return;
      const field = input.getBoundingClientRect(), box = modal.getBoundingClientRect();
      const bottom = Math.min(box.bottom, top + height) - 12, upper = Math.max(box.top, top) + 12;
      if (field.bottom > bottom) modal.scrollTop += field.bottom - bottom;
      else if (field.top < upper) modal.scrollTop -= upper - field.top;
    }
    function scheduleViewport(ensureInput = false) {
      if (root.hidden || destroyed) return;
      revealInput = revealInput || ensureInput;
      if (viewportFrame) return;
      viewportFrame = requestAnimationFrame(() => {
        viewportFrame = 0; const reveal = revealInput; revealInput = false; syncViewport(reveal);
      });
    }
    on(window,'resize',() => scheduleViewport(true));
    if (viewport) {
      on(viewport,'resize',() => scheduleViewport(true));
      // Panning/scrolling must not pull a reader back from the submit button or fine print.
      on(viewport,'scroll',() => scheduleViewport());
    }
    on(input,'focus',() => scheduleViewport(true));
    function stored(key) { try { return localStorage.getItem(key); } catch (_) { storageAvailable = false; return null; } }
    function remember(key) { try { localStorage.setItem(key, 'true'); } catch (_) {} }
    // A visitor who has already signed up (this popup or the earlier offer) may see the code again.
    const claimed = () => ownResult === 'success' || Boolean(stored(keys.submitted)) || Boolean(stored('popup_offer_submitted'));
    function syncBadge() {
      if (!badge) return;
      badge.hidden = !(root.hidden && !destroyed && !navigating && !submitting && !challengeActive && Boolean(gate?.canShow()));
    }
    const cookieOpen = () => Boolean(window.Cookiebot?.dialog?.visible);
    const consentReady = () => {
      const bot = window.Cookiebot, c = bot?.consent;
      return bot?.hasResponse === true && c?.method === 'explicit' &&
        ['preferences','statistics','marketing'].every(k => typeof c[k] === 'boolean') && !cookieOpen();
    };
    if (form) {
      try {
        const receipt = JSON.parse(sessionStorage.getItem(keys.pending) || 'null');
        const age = receipt && Date.now() - receipt.started;
        if (receipt && Number.isFinite(receipt.started) && age >= 0 && age <= 600000 &&
            receipt.path === location.pathname && receipt.form === form.id && location.hash === '#' + form.id) {
          const status = form.querySelector('[data-result]')?.dataset.status;
          ownResult = status === 'success' ? 'success' : 'error';
          if (ownResult === 'success') { root.classList.add('is-returning'); remember(keys.submitted); }
          else if (status !== 'error' || !error.textContent.trim()) error.textContent = 'We could not confirm your signup. Please try again.';
          sessionStorage.removeItem(keys.pending);
        } else if (receipt && (!Number.isFinite(receipt.started) || age < 0 || age > 600000)) sessionStorage.removeItem(keys.pending);
      } catch (_) { /* A query alone never confirms a signup. */ }
    }
    const loadImage = image => {
      if (!image || image.hasAttribute('src')) return;
      if (image.dataset.srcset) image.srcset = image.dataset.srcset;
      image.src = image.dataset.src;
    };
    const stop = () => { clearInterval(timer); timer = null; video.pause(); };
    function cycle() {
      const old = index; index = (index + 1) % slides.length;
      loadImage(slides[index].querySelector('img'));
      slides.forEach((slide,i) => { slide.classList.toggle('is-on',i === index); slide.classList.toggle('is-was',i === old); });
      segs.forEach((seg,i) => { seg.classList.remove('is-run','is-done'); void seg.offsetWidth; if (i < index) seg.classList.add('is-done'); if (i === index) seg.classList.add('is-run'); });
    }
    function media() {
      stop();
      if (root.hidden || document.hidden || motion.matches || submitting) return;
      if (step === 3) {
        if (!video.hasAttribute('src') && /^https:\/\/cdn\.shopify\.com\//.test(video.dataset.src)) video.src = video.dataset.src;
        if (video.hasAttribute('src')) video.play().catch(() => video.classList.remove('is-playing'));
      } else timer = setInterval(cycle,5000);
    }
    function prepareStep(n) {
      if (!demo && n === 3 && !claimed()) return;
      step = n; steps.forEach(node => { node.hidden = Number(node.dataset.step) !== n; });
      root.classList.toggle('is-email',n === 2);
      root.classList.toggle('is-done',n === 3); error.hidden = !(n === 2 && ownResult === 'error');
      if (n === 3) loadImage(poster);
      modal.scrollTop = 0;
    }
    function showStep(n) {
      prepareStep(n); syncViewport(); media(); (n === 2 ? input : modal).focus({preventScroll:true});
      scheduleViewport(n === 2);
    }
    // Hiding for consent, navigation or CAPTCHA never edits successful form controls.
    function hide(restoreFocus = true) {
      clearViewport();
      if (root.hidden) { syncBadge(); return; }
      stop(); clearTimeout(copyTimer); root.hidden = true;
      video.classList.remove('is-playing'); video.removeAttribute('src'); video.load();
      document.body.style.overflow = previousOverflow;
      inertNodes.forEach(([node,was]) => { node.inert = was; }); inertNodes = [];
      syncBadge();
      if (restoreFocus && previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
    }
    function close() {
      pending = 0; ownResult = ''; hide();
      if (submitting) submissionDismissed = true;
      else input.value = '';
      if (!demo) remember(keys.dismissed);
    }
    function open(n) {
      if (destroyed || navigating || challengeActive || (submitting && submissionDismissed)) return;
      if (demo ? (cookieOpen() || (window.Cookiebot && !window.Cookiebot.hasResponse)) : !consentReady()) { pending = n; return; }
      pending = 0; prepareStep(n);
      if (root.hidden) {
        previousFocus = document.activeElement; previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        if (!submitting) [...document.body.children].forEach(node => {
          if (node.contains(root) || node.tagName === 'SCRIPT' || node.tagName === 'STYLE' || /cookiebot/i.test(node.id)) return;
          inertNodes.push([node,node.inert]); node.inert = true;
        });
        root.hidden = false; loadImage(slides[0].querySelector('img'));
        slides[index].classList.add('is-on'); segs[index].classList.add('is-run');
      }
      showStep(n); syncBadge();
    }
    function offerReady() {
      if (destroyed || navigating || challengeActive) return;
      if (pending) { open(pending); return; }
      if (submitting) return;
      if (ownResult) { open(ownResult === 'success' ? 3 : 2); return; }
      if (gate?.canShow() && !stored(keys.dismissed) && !stored(keys.submitted) &&
          !stored('popup_offer_dismissed') && !stored('popup_offer_submitted')) open(1);
      else syncBadge();
    }
    function externalChallenge() {
      return [...document.querySelectorAll('.shopify-challenge__container,iframe[src*="hcaptcha.com"]')].some(node => {
        if (root.contains(node)) return false;
        if (node.tagName === 'IFRAME') {
          try { const host = new URL(node.src).hostname; if (host !== 'hcaptcha.com' && !host.endsWith('.hcaptcha.com')) return false; } catch (_) { return false; }
        }
        const rect = node.getBoundingClientRect();
        if (rect.width < 100 || rect.height < 100) return false;
        for (let el = node; el; el = el.parentElement) {
          const style = getComputedStyle(el);
          if (el.hidden || style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
        }
        return true;
      });
    }
    function resetBusy() {
      submitting = false; retryDue = false; challengeActive = false;
      clearTimeout(submitTimer); clearInterval(challengePoll); challengeObserver?.disconnect(); cancelAnimationFrame(challengeFrame);
      root.classList.remove('is-submitting'); submit.textContent = submitLabel; submit.removeAttribute('aria-busy');
      form?.removeAttribute('aria-busy'); modal.setAttribute('aria-modal','true');
      syncBadge();
    }
    function retry() {
      if (destroyed || !submitting || navigating) return;
      if (externalChallenge()) { challengeActive = true; retryDue = true; hide(false); return; }
      resetBusy(); ownResult = 'error'; error.textContent = 'Your signup has not finished. Please try again.'; error.hidden = false;
      if (!submissionDismissed) { hide(false); open(2); }
    }
    function checkChallenge() {
      challengeFrame = null;
      if (!submitting || destroyed || navigating) return;
      const active = externalChallenge(), wasActive = challengeActive;
      challengeActive = active;
      if (active) hide(false);
      else if (wasActive && !submissionDismissed) {
        if (retryDue) retry();
        else if (consentReady()) open(2);
        else pending = 2;
      }
    }
    if (form) on(form,'submit',event => {
      if (!input.validity.valid) { event.preventDefault(); error.textContent = 'Please enter a valid email address.'; error.hidden = false; input.focus(); return; }
      // Do not cancel a valid submit, including one resumed by Shopify after CAPTCHA.
      try { sessionStorage.setItem(keys.pending,JSON.stringify({started:Date.now(),path:location.pathname,form:form.id})); } catch (_) {}
      ownResult = ''; pending = 0; submitting = true; error.hidden = true;
      submissionDismissed = false; retryDue = false;
      stop(); root.classList.add('is-submitting'); form.setAttribute('aria-busy','true');
      submit.textContent = 'Preparing your voucher...'; submit.setAttribute('aria-busy','true');
      modal.setAttribute('aria-modal','false');
      inertNodes.forEach(([node,was]) => { node.inert = was; }); inertNodes = [];
      challengeObserver?.disconnect();
      challengeObserver = new MutationObserver(() => { if (!challengeFrame) challengeFrame = requestAnimationFrame(checkChallenge); });
      challengeObserver.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['style','class','hidden','aria-hidden']});
      clearInterval(challengePoll); challengePoll = setInterval(checkChallenge,150);
      checkChallenge(); clearTimeout(submitTimer); submitTimer = setTimeout(retry,20000);
    });
    if (badge) on(badge,'click',() => { if (gate?.canShow()) open(claimed() ? 3 : 1); });
    on(root,'click',event => {
      const button = event.target.closest('button,[data-close]'); if (!button) return;
      if (button.hasAttribute('data-close')) close();
      else if (button.hasAttribute('data-next')) showStep(2);
      else if (demo && button.dataset.review) showStep(Number(button.dataset.review));
      else if (demo && button.hasAttribute('data-claim')) { error.textContent = input.validity.valid ? 'Preview: sign-up disabled. No email has been saved or sent.' : 'Please enter a valid email address.'; error.hidden = false; }
      else if (button.hasAttribute('data-copy')) {
        const label = button.querySelector('[data-copy-label]'), code = root.querySelector('[data-code]').textContent.trim();
        if (!navigator.clipboard) { label.textContent = 'Select code'; return; }
        navigator.clipboard.writeText(code).then(() => {
          if (root.hidden) return;
          label.textContent = 'Copied'; button.querySelector('.i-copy').hidden = true; button.querySelector('.i-tick').hidden = false;
          clearTimeout(copyTimer); copyTimer = setTimeout(() => { label.textContent = 'Copy'; button.querySelector('.i-copy').hidden = false; button.querySelector('.i-tick').hidden = true; },1800);
        }).catch(() => { label.textContent = 'Select code'; });
      }
    });
    on(document,'keydown',event => {
      if (root.hidden || cookieOpen() || submitting) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (demo && event.key === 'Enter' && event.target === input) event.preventDefault();
      if (event.key !== 'Tab') return;
      const focusable = [...modal.querySelectorAll('button,input,a[href]')].filter(el => !el.disabled && el.getClientRects().length);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && (document.activeElement === first || document.activeElement === modal)) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || document.activeElement === modal)) { event.preventDefault(); first?.focus(); }
    });
    on(video,'playing',() => { if (!root.hidden && step === 3 && !motion.matches) video.classList.add('is-playing'); });
    on(video,'error',() => video.classList.remove('is-playing'));
    on(document,'visibilitychange',() => { root.classList.toggle('is-paused',document.hidden); media(); });
    on(motion,'change',() => { if (motion.matches) { index = 0; slides.forEach((slide,i) => { slide.classList.toggle('is-on',i === 0); slide.classList.remove('is-was'); }); video.classList.remove('is-playing'); } media(); });
    function suspend() { if (navigating) return; if (!root.hidden) pending = step; hide(); }
    ['CookiebotOnAccept','CookiebotOnDecline','CookiebotOnConsentReady'].forEach(name => on(window,name,() => {
      if (demo) { if (pending) open(pending); }
      else if (ownResult && consentReady()) open(ownResult === 'success' ? 3 : 2);
    }));
    on(window,'CookiebotOnDialogDisplay',suspend);
    on(window,'pagehide',() => { navigating = true; clearViewport(); clearTimeout(submitTimer); clearInterval(challengePoll); challengeObserver?.disconnect(); cancelAnimationFrame(challengeFrame); stop(); if (!submitting) hide(false); syncBadge(); });
    on(window,'pageshow',event => {
      navigating = false;
      if (event.persisted && submitting) {
        resetBusy(); ownResult = 'error'; error.textContent = 'Please try again if your signup did not finish.';
        hide(false); if (!submissionDismissed) open(2);
      }
      syncBadge();
    });
    const section = root.closest('.shopify-section');
    on(document,'shopify:section:select',event => { if (editor && event.target === section) open(Number(root.dataset.previewStep)); });
    on(document,'shopify:section:deselect',event => { if (event.target === section) hide(); });
    on(document,'shopify:section:unload',event => { if (event.target === section) { destroyed = true; hide(); resetBusy(); controller.abort(); instances.delete(root.id); } });
    instances.set(root.id,{close});
    if (demo) { if (!editor && requested) open(requested); }
    else {
      if (ownResult) { prepareStep(ownResult === 'success' ? 3 : 2); open(ownResult === 'success' ? 3 : 2); }
      function initGate() {
        if (destroyed || gate || !window.WscCookieUI) return;
        gate = window.WscCookieUI.createOfferGate({delayMilliseconds:10000,canPersist:() => { stored(keys.dismissed); return storageAvailable; },suspend,ready:offerReady});
      }
      if (document.readyState === 'loading') on(document,'DOMContentLoaded',initGate); else initGate();
    }
  }
  document.querySelectorAll('[data-wsc-diamond]').forEach(init);
  if (!window.WscDiamondLoadBound) {
    window.WscDiamondLoadBound = true;
    document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-wsc-diamond]').forEach(init));
  }
})();
